module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-38.22d0f47f.png";